/** How roles are named on screen; the tenant's own titles, the same in every language. */
export const ROLE_LABEL: Record<string, string> = { rep: 'Sales rep', supervisor: 'Sales director', head: 'General manager', admin: 'Pricing admin' }

export const roleLabel = (role: string) => ROLE_LABEL[role] ?? role
